@for (notification of normalizedNotifications(); track notification.id) {
  <article>
    <portal-notification-live-view-title-image [notification]="notification" />

    <portal-notification-live-view-item
      [class.with-border-top]="$first === false"
      [language]="language()"
      [notification]="notification"
      [showTitle]="showTitle()"
      [showTitleImage]="false"
    />

    @if (showPublicationDate() && notification.publishedAt != null) {
      <footer class="text-muted pt-2 px-3">
        <small>
          {{ 'myNotifications.publishedAt' | translate: { date: notification.publishedAt | portalTimeAgo } }}
        </small>
      </footer>
    }
  </article>
}
